import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { Layout } from '../../api/v1/models/layout';
import { ConfigRepository } from '../repositories/config.repository';
import { map } from 'rxjs/operators';
import { WINDOW } from '../tokens/window';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver);
  private config = inject(ConfigRepository);

  constructor() {
    this.isMobile$.subscribe(isMobile => this._isMobile = isMobile);

    this.breakpointObserver.observe('(max-width: 1279px)').subscribe(state => {
      this._isTablet = state.matches;
    });
  }

  isMobile$: Observable<boolean> = this.config.layout$.pipe(
    switchMap(layout => {
      if (layout === Layout.Fresh) {
        return this.breakpointObserver.observe('(max-width: 959px)');
      }

      return this.breakpointObserver.observe('(max-width: 767px)');
    }),
    map((state: BreakpointState) => state.matches),
    shareReplay({refCount: true, bufferSize: 1}),
  );

  private _isMobile: boolean;
  private _isTablet: boolean;

  private window = inject(WINDOW);

  get isMobile(): boolean {
    return this._isMobile;
  }
  get isTablet(): boolean {
    return this._isTablet;
  }

  get isAndroid(): boolean {
    const uaString = this.window.navigator.userAgent.toLowerCase();
    return /android/.test(uaString);
  }
}
